export class Manufacturer {
  Id: number;
  Name: string;
  CreatedAt: string;
  UpdatedAt: string;
}
